import ".././styles/BoardmembersPreview.css";
import BoardmemberCard from "./BoardmemberCard";
import { HashLink as Link } from 'react-router-hash-link';
import React, { useState, useEffect, useLayoutEffect } from "react";

// --- Configuration for Google Sheets API ---
const GOOGLE_API_KEY = 'AIzaSyCLfnoX4kMuKDpNMQ9HZ2qJP28aRKNd2Hg';
const SPREADSHEET_ID = '16I9JOyUgHldKvU8AqhPl8ABxFRwBfb_mk37zbMhU1mU';
const BOD_SHEET_RANGE = 'boardOfDirectors!A:E';

function BoardmembersPreview() {
    const [bod, setBod] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); 
            setError(null);   

            try {
                // Fetch Board of Directors data using Google Sheets API
                const bodApiUrl = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${BOD_SHEET_RANGE}?key=${GOOGLE_API_KEY}`;
                const bodResponse = await fetch(bodApiUrl);

                if (!bodResponse.ok) {
                    const errorJson = await bodResponse.json();
                    const errorMessage = errorJson.error ? errorJson.error.message : bodResponse.statusText;
                    throw new Error(`HTTP Error! Status: ${bodResponse.status} for Board of Directors - ${errorMessage}`);
                }
                
                const bodJsonData = await bodResponse.json();
                
                if (bodJsonData && bodJsonData.values) {
                    const bodHeaders = bodJsonData.values[0]; // The first row is headers
                    const bodRows = bodJsonData.values.slice(1); // All rows except the header

                    const parsedBod = bodRows.map(row => {
                        let item = {};
                        bodHeaders.forEach((header, index) => {
                            item[header.toLowerCase()] = row[index];
                        });
                        return item;
                    });
                    
                    // To get the first four board of directors
                    const firstFourBod = parsedBod.slice(0, 4);
                    setBod(firstFourBod);
                } else {
                    console.warn("Google Sheets API Board of Directors data not found or response is empty.", bodJsonData);
                    setBod([]);
                }
            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err); // Set error state
            } finally {
                setLoading(false); // Set loading to false after fetch
            }
        };

        fetchData(); // Call the fetchData function
    }, []); // Run once on mount

    // Only scroll when loading is false and no error occurred
    useLayoutEffect(() => {
        if (!loading && !error) { 
            window.scrollTo(0, 0);
        }
    }, [loading, error]);

    if (loading) {
        return <p>Loading board members...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    return (
        <div className="boardmembers-preview-container container section">
            <div className="boardmembers-preview wrapper">
                <h2 className="section-title">
                    Our Board Members
                </h2>
                <div className="container">
                <div className="boardmembers-section">
                    {bod.length > 0 ? (
                        bod.map((boardMember) => (
                            <BoardmemberCard
                                key={boardMember.id} // Ensure 'id' exists in your parsed data
                                name={boardMember.name}
                                position={boardMember.position}
                                description={boardMember.description}
                                image={boardMember.image}
                            />
                            ))
                        ) : (
                        <p>No board of directors found.</p>
                    )}
                </div>
                </div>
                <Link to="/aboutus#boardmembers" className="news-view-more button-1">View More</Link>
            </div>
        </div>
    );
}

export default BoardmembersPreview;